import Carousel from "react-multi-carousel";
import styles from "./RelatedEntities.module.scss";
import { Fragment, useMemo } from "react";
import { FacultyCard, InstitutionCard } from "..";
import { carouselResponsive } from "Explore/Utils";

const RelatedEntities = ({
  entities,
  entityType,
  responsive = carouselResponsive,
}) => {
  const { render, title } = useMemo(() => {
    switch (entityType) {
      case "faculty":
        return {
          render: (props) => (
            <FacultyCard
              {...props}
              className={styles["related-faculty-card"]}
              simpleMode
            />
          ),
          title: "Related Faculties",
        };
      case "institution":
        return {
          render: (props) => (
            <InstitutionCard
              {...props}
              className={styles["related-institution-card"]}
              simpleMode
            />
          ),
          title: "Related Institutions",
        };
      default:
        return null;
    }
  }, [entityType]);

  return (
    <Carousel
      className={styles["related-entities"]}
      responsive={responsive}
      arrows={true}
      draggable
      partialVisible
      focusOnSelect={false}
    >
      {entities.data.length > 0 &&
        entities.data.map((entity, i) => (
          <Fragment key={i}>
            {render({
              data: entity,
            })}
          </Fragment>
        ))}
    </Carousel>
  );
};

export default RelatedEntities;
